module.exports = __webpack_public_path__ + "static/media/compass-slash.21efe5db.svg";